import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";


import Chip from "@mui/material/Chip";
import Langganan1 from "../../assets/images/langganan/1.png";
import Langganan2 from "../../assets/images/langganan/2.png";
import Langganan3 from "../../assets/images/langganan/3.png";


interface ICardLanggananProps {
    id: number;
    harga: string;
    hargaDis?: string;
    diskon?: string;
    click: () => void;
    href: string;
}

const CardLangganan = ({
    id,
    harga,
    hargaDis,
    diskon,
    click,
    href,
}: ICardLanggananProps) => {
    return (
        <React.Fragment>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent={id === 2 ? "flex-end" : "space-between"}
                gap={2}
                sx={{
                    border: "1px solid #A8B4AF",
                    borderRadius: "8px",
                    paddingX: 2,
                    paddingY: 2.5,
                    height: id === 2 ? 480 : undefined,
                }}
            >
                <Stack>
                    <Stack
                        gap={0.5}
                        justifyContent="center"
                        alignItems={"center"}
                    >
                        <Typography
                            fontSize={"20px"}
                            fontWeight={500}
                            color="#464E4B"
                        >
                            {id === 1
                                ? "Langganan 1 bulan"
                                : id === 2
                                ? "Langganan 1 tahun"
                                : "Langganan 3 bulan"}
                        </Typography>
                        <Typography color="#A8B4AF">
                            {id === 1
                                ? "Harga normal"
                                : id === 2
                                ? "Rekomendasi"
                                : "Paket ekonomis"}
                        </Typography>
                    </Stack>
                    <Box
                        display="flex"
                        flexDirection="row"
                        justifyContent="center"
                        alignItems={"center"}
                        sx={{ marginTop: id === 1 ? 0 : id === 2 ? 0 : -1 }}
                    >
                        <Box
                            display="flex"
                            flexDirection="column-reverse"
                            justifyContent="center"
                            alignItems={"flex-end"}
                        >
                            {id === 1 ? (
                                <img
                                    src={Langganan1}
                                    width={224}
                                    height={224}
                                    style={{ objectFit: "contain" }}
                                    alt="Langganan 1"
                                />
                                
                            ) : id === 2 ? (
                                <img
                                    src={Langganan2}
                                    width={224}
                                    height={224}
                                    style={{ objectFit: "contain" }}
                                    alt="Langganan 2"
                                />
                            ) : (
                                <img
                                    src={Langganan3}
                                    width={224}
                                    height={224}
                                    style={{ objectFit: "contain" }}
                                    alt="Langganan 3"
                                />
                            )}
                        </Box>
                    </Box>
                    <Stack
                        gap={1}
                        justifyContent="center"
                        alignItems={"center"}
                    >
                        {hargaDis && (
                            <Stack
                                gap={1}
                                justifyContent="center"
                                alignItems={"center"}
                                flexDirection={"row"}
                                sx={{ marginTop: -2 }}
                            >
                                <Typography
                                    align="center"
                                    style={{
                                        textDecorationLine: "line-through",
                                    }}
                                    color="#7C8883"
                                >
                                    {hargaDis}
                                </Typography>
                                <Chip color="error" label={diskon} />
                            </Stack>
                        )}

                        <Typography
                            fontSize={id === 2 ? "32px" : "24px"}
                            fontWeight={id === 2 ? 700 : 600}
                            color="#2D312F"
                        >
                            {harga}
                        </Typography>
                    </Stack>
                </Stack>
                <Button
                    variant={id === 2 ? "contained" : "outlined"}
                    onClick={click}
                    href={href}
                    disableElevation
                >
                    <Typography fontWeight={500}>Pilih Langganan</Typography>
                </Button>
            </Box>
        </React.Fragment>
    );
};

export default CardLangganan;
